import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderTop: '0.0625rem solid #f1f1f1',
    borderBottom: '0.0625rem solid #f1f1f1',
    maxWidth: '480px',

    '& .icon': {
      marginRight: '0.125rem',
      minWidth: '0.75rem',
      minHeight: '0.75rem',
      color: theme.palette.primary.main
    },

    '& .text': {
      overflow: 'hidden',
      maxWidth: '100px',
      fontSize: theme.size.sm,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: '#7F8487'
    },

    [theme.breakpoints.down(767)]: {
      maxWidth: 'unset'
    }
  },

  textfield: {
    width: '80%',
    marginBottom: '10px'
  },

  label: {
    display: 'flex',

    '& .text': {
      opacity: '0.7',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.size.sm
    }
  },

  icon: {
    marginTop: '0.125rem',
    marginRight: '0.705rem',
    fontSize: theme.size.base
  },

  'Live-Chat': {
    color: '#88388F'
  },

  Email: {
    color: '#697B64'
  },

  SMS: {
    color: '#C87A3C'
  },

  control: {
    '& .MuiRadio-colorPrimary.Mui-checked': {
      color: theme.palette.primary.main
    },

    '& .MuiSvgIcon-fontSizeSmall': {
      fontSize: theme.size.lg
    }
  },

  radio: {
    marginTop: '1px'
  },

  controlLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: theme.size.sm,
      fontFamily: 'Lato',
      textAlign: 'center'
    }
  },

  controlLabelBold: {
    '& .MuiFormControlLabel-label': {
      fontSize: theme.size.sm,
      fontFamily: 'Lato',
      textAlign: 'center'
    }
  },

  menu: {
    '& .MuiMenu-paper': {
      padding: '0 1rem'
    }
  },

  chatFilters: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginRight: '1rem',
    padding: '0.75rem 0',
    cursor: 'pointer'
  },

  chatFiltersLast: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '0.75rem 0',
    cursor: 'pointer'
  }
}))

export default useStyles
